<script setup lang="ts">
const countries = [
    {
        name: 'France',
        code: 'FR',
        cities: [
            'Paris',
            'Marseille',
            'Toulouse',
            'Nice',
            'Lyon',
            'Bordeaux',
            'Strasbourg',
            'Montpellier',
            'Reims',
            'Toulon'
        ]
    },
    {
        name: 'Germany',
        code: 'DE',
        cities: ['Berlin', 'Hamburg', 'Stuttgart', 'Munich', 'Cologne']
    },
    {
        name: 'Belgium',
        code: 'BE',
        cities: ['Antwerp', 'Bruges', 'Brussels', 'Liege', 'Ostende']
    },
    {
        name: 'Switzerland',
        code: 'CH',
        cities: ['Zurich', 'Basel', 'Lausanne', 'Geneva', 'Bern']
    },
    {
        name: 'UK',
        code: 'GB',
        cities: ['London', 'Birmingham', 'Manchester', 'Glasgow', 'Edinburgh']
    },
    {
        name: 'Netherland',
        code: 'NL',
        cities: ['Amsterdam', 'Rotterdam', 'Utrecht', 'Eindhoven', 'Maastricht']
    },
    {
        name: 'Italy',
        code: 'IT',
        cities: ['Rome', 'Milan', 'Turin', 'Florence', 'Genes']
    },
    {
        name: 'Spain',
        code: 'ES',
        cities: ['Madrid', 'Barcelona', 'Malaga', 'Valencia', 'Seville']
    },
    {
        name: 'Portugal',
        code: 'PT',
        cities: ['Lisbon', 'Porto', 'Braga', 'Coimbra', 'Faro']
    }
]
</script>

<template>
    <div class="city-list">
        <ul class="md:row-[1/_span_2] md:self-center w-fit">
            <li class="country">{{ $t('country.france') }}</li>
            <div class="city-container">
                <div
                    v-for="(city, index) of countries[0]?.cities || []"
                    :key="city"
                    :class="[index > 2 && 'hidden md:block']"
                >
                    <a
                        class="city-name"
                        :href="`/cities/${city.toLowerCase()}-${countries[0]?.code}`"
                        :title="city"
                    >
                        {{ city }}
                    </a>
                </div>
            </div>
        </ul>

        <ul
            v-for="country of countries.slice(1)"
            :key="country.name"
            class="w-fit"
        >
            <li class="country">
                {{ $t(`country.${country.name.toLowerCase()}`) }}
            </li>
            <div class="city-container">
                <div
                    v-for="(city, index) of country.cities"
                    :key="city"
                    :class="[index > 2 && 'hidden md:block']"
                >
                    <a
                        class="city-name"
                        :href="`/cities/${city.toLowerCase()}-${country.code}`"
                        :title="city"
                    >
                        {{ city }}
                    </a>
                </div>
            </div>
        </ul>
    </div>
</template>

<style scoped>
.city-list {
  @apply px-4 pb-4 md:py-9 md:px-14 grid grid-rows-5 md:grid-rows-2 grid-flow-col gap-y-2.5 gap-x-4 text-gray-l-700 md:justify-between mx-auto max-w-[1280px];
}
.city-list > li,
.city-list a {
  line-height: 120%;
}
.city-list .city-name {
  @apply flex text-zinc-700 hover:text-sky-400 active:text-sky-700 active:font-semibold whitespace-nowrap text-ellipsis text-[13px] xl:text-[15px];
}
.city-list .country {
  @apply font-bold text-[15px] py-2 pr-4 text-sky-700;
}
.city-list .city-container {
  @apply flex flex-col gap-2 md:block;
}
</style>
